'use client';

import {
  NavigationBar,
  NavigationBarProps,
} from '@bts-web/design-system/component/navigation-bar';
import { Language, RTL_LANGUAGES } from '@bts-web/utils-lokalise';
import { css } from '@bts-web/utils-style-engine';
import { useClientUserInfo } from '../../userinfo/InitialUserInfoFetcherAndParser/utils/useClientUserInfo';

type ThemedNavigationBarProps = NavigationBarProps['external'] & {
  showBorderBottom?: boolean;
  className?: string;
};

const ThemedNavigationBar = ({
  title,
  isTitleCentered = true,
  NavigationLeftSlot,
  NavigationRightSlot,
  showBorderBottom = false,
  className,
}: ThemedNavigationBarProps) => {
  const { language } = useClientUserInfo();

  const dir = RTL_LANGUAGES.includes(language as Language) ? 'rtl' : 'ltr';

  return (
    <NavigationBar
      className={`${css({
        display: 'flex',
        minHeight: '48px',
        alignItems: 'center',
        backgroundColor: 'screen_background.primary',
        '& li': {
          minWidth: '74px',
        },
        '& li[data-element="navigation-right-slot"] button': {
          px: 'medium',
          py: 'extra_small',
        },
        '& li[data-element="navigation-left-slot"] button': {
          px: 'medium',
          py: 'extra_small',
        },
        '& [data-element="empty-navigation-slot"]': {
          width: '74px',
        },
        ...(showBorderBottom
          ? {
              width: 'auto',
              borderBottomWidth: '1px',
              borderBottomColor: 'neutrals.divider',
            }
          : {}),
      })} ${className ?? ''}`}
      titleClassName={css({
        display: 'flex',
        color: 'neutrals.text_primary',
        fontSize: 'body.medium_medium',
        fontWeight: 'body.medium_medium',
        lineHeight: 'body.medium_medium',
        letterSpacing: 'body.medium_medium',
        flexGrow: '1',
        '&[data-visual="centered"]': {
          justifyContent: 'center',
        },
      })}
      title={title}
      isTitleCentered={isTitleCentered}
      NavigationLeftSlot={NavigationLeftSlot}
      NavigationRightSlot={NavigationRightSlot}
      dir={dir}
    />
  );
};

export { ThemedNavigationBar as NavigationBar };
